import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { SearchTab } from '../hooks/use-search-state';

interface SearchTabBarProps {
  activeTab: SearchTab;
  onTabChange: (tab: SearchTab) => void;
}

export function SearchTabBar({ activeTab, onTabChange }: SearchTabBarProps) {
  return (
    <Tabs value={activeTab} onValueChange={(v) => onTabChange(v as SearchTab)}>
      <TabsList>
        <TabsTrigger value="places" title="Places" />
        <TabsTrigger value="people" title="People" />
        <TabsTrigger value="menu-items" title="Menu Items" />
      </TabsList>
    </Tabs>
  );
}
